/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BaseResponse from '../model/BaseResponse';
import ManagerAccountControllerDtoCategoryListResponse from '../model/ManagerAccountControllerDtoCategoryListResponse';
import ManagerAccountControllerDtoFindPasswordRequest from '../model/ManagerAccountControllerDtoFindPasswordRequest';
import ManagerAccountControllerDtoLoginInfoResponse from '../model/ManagerAccountControllerDtoLoginInfoResponse';
import ManagerAccountControllerDtoLoginRequest from '../model/ManagerAccountControllerDtoLoginRequest';
import ManagerAccountControllerDtoLoginResponse from '../model/ManagerAccountControllerDtoLoginResponse';
import ManagerAccountControllerDtoLoginTwoFaAuthRequest from '../model/ManagerAccountControllerDtoLoginTwoFaAuthRequest';
import ManagerAccountControllerDtoLoginTwoFaAuthResponse from '../model/ManagerAccountControllerDtoLoginTwoFaAuthResponse';
import ManagerAccountControllerDtoMyInfoResponse from '../model/ManagerAccountControllerDtoMyInfoResponse';
import ManagerAccountControllerDtoMyNameChangeRequest from '../model/ManagerAccountControllerDtoMyNameChangeRequest';
import ManagerAccountControllerDtoMyNameChangeResponse from '../model/ManagerAccountControllerDtoMyNameChangeResponse';
import ManagerAccountControllerDtoMyPasswordChangeRequest from '../model/ManagerAccountControllerDtoMyPasswordChangeRequest';
import ManagerAccountControllerDtoMyRemoveTwoFactorRequest from '../model/ManagerAccountControllerDtoMyRemoveTwoFactorRequest';
import ManagerAccountControllerDtoNotificationListResponse from '../model/ManagerAccountControllerDtoNotificationListResponse';
import ManagerAccountControllerDtoNotificationTokenCreateRequest from '../model/ManagerAccountControllerDtoNotificationTokenCreateRequest';
import ManagerAccountControllerDtoNotificationsMarkingAsReadRequest from '../model/ManagerAccountControllerDtoNotificationsMarkingAsReadRequest';
import ManagerAccountControllerDtoNotificationsRemoveRequest from '../model/ManagerAccountControllerDtoNotificationsRemoveRequest';

/**
* ManagerAccount service.
* @module api/ManagerAccountApi
* @version 1.0
*/
export default class ManagerAccountApi {

    /**
    * Constructs a new ManagerAccountApi. 
    * @alias module:api/ManagerAccountApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiManagerAccountCategoryListPost operation.
     * @callback module:api/ManagerAccountApi~apiManagerAccountCategoryListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ManagerAccountControllerDtoCategoryListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/ManagerAccountApi~apiManagerAccountCategoryListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ManagerAccountControllerDtoCategoryListResponse}
     */
    apiManagerAccountCategoryListPost(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = ManagerAccountControllerDtoCategoryListResponse;
      return this.apiClient.callApi(
        '/api/ManagerAccount/CategoryList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerAccountExtendLoginSessionPost operation.
     * @callback module:api/ManagerAccountApi~apiManagerAccountExtendLoginSessionPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/ManagerAccountApi~apiManagerAccountExtendLoginSessionPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiManagerAccountExtendLoginSessionPost(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/ManagerAccount/ExtendLoginSession', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerAccountFindPasswordPost operation.
     * @callback module:api/ManagerAccountApi~apiManagerAccountFindPasswordPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerAccountControllerDtoFindPasswordRequest} [managerAccountControllerDtoFindPasswordRequest] 
     * @param {module:api/ManagerAccountApi~apiManagerAccountFindPasswordPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiManagerAccountFindPasswordPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerAccountControllerDtoFindPasswordRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/ManagerAccount/FindPassword', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerAccountLoginInfoPost operation.
     * @callback module:api/ManagerAccountApi~apiManagerAccountLoginInfoPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ManagerAccountControllerDtoLoginInfoResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/ManagerAccountApi~apiManagerAccountLoginInfoPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ManagerAccountControllerDtoLoginInfoResponse}
     */
    apiManagerAccountLoginInfoPost(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = ManagerAccountControllerDtoLoginInfoResponse;
      return this.apiClient.callApi(
        '/api/ManagerAccount/LoginInfo', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerAccountLoginPost operation.
     * @callback module:api/ManagerAccountApi~apiManagerAccountLoginPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ManagerAccountControllerDtoLoginResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerAccountControllerDtoLoginRequest} [managerAccountControllerDtoLoginRequest] 
     * @param {module:api/ManagerAccountApi~apiManagerAccountLoginPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ManagerAccountControllerDtoLoginResponse}
     */
    apiManagerAccountLoginPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerAccountControllerDtoLoginRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = ManagerAccountControllerDtoLoginResponse;
      return this.apiClient.callApi(
        '/api/ManagerAccount/Login', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerAccountLoginTwofaAuthPost operation.
     * @callback module:api/ManagerAccountApi~apiManagerAccountLoginTwofaAuthPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ManagerAccountControllerDtoLoginTwoFaAuthResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerAccountControllerDtoLoginTwoFaAuthRequest} [managerAccountControllerDtoLoginTwoFaAuthRequest] 
     * @param {module:api/ManagerAccountApi~apiManagerAccountLoginTwofaAuthPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ManagerAccountControllerDtoLoginTwoFaAuthResponse}
     */
    apiManagerAccountLoginTwofaAuthPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerAccountControllerDtoLoginTwoFaAuthRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = ManagerAccountControllerDtoLoginTwoFaAuthResponse;
      return this.apiClient.callApi(
        '/api/ManagerAccount/LoginTwofaAuth', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerAccountLogoutPost operation.
     * @callback module:api/ManagerAccountApi~apiManagerAccountLogoutPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/ManagerAccountApi~apiManagerAccountLogoutPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiManagerAccountLogoutPost(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/ManagerAccount/Logout', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerAccountMyInfoPost operation.
     * @callback module:api/ManagerAccountApi~apiManagerAccountMyInfoPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ManagerAccountControllerDtoMyInfoResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/ManagerAccountApi~apiManagerAccountMyInfoPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ManagerAccountControllerDtoMyInfoResponse}
     */
    apiManagerAccountMyInfoPost(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = ManagerAccountControllerDtoMyInfoResponse;
      return this.apiClient.callApi(
        '/api/ManagerAccount/MyInfo', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerAccountMyNameChangePost operation.
     * @callback module:api/ManagerAccountApi~apiManagerAccountMyNameChangePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ManagerAccountControllerDtoMyNameChangeResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerAccountControllerDtoMyNameChangeRequest} [managerAccountControllerDtoMyNameChangeRequest] 
     * @param {module:api/ManagerAccountApi~apiManagerAccountMyNameChangePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ManagerAccountControllerDtoMyNameChangeResponse}
     */
    apiManagerAccountMyNameChangePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerAccountControllerDtoMyNameChangeRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = ManagerAccountControllerDtoMyNameChangeResponse;
      return this.apiClient.callApi(
        '/api/ManagerAccount/MyNameChange', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerAccountMyPasswordChangePost operation.
     * @callback module:api/ManagerAccountApi~apiManagerAccountMyPasswordChangePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerAccountControllerDtoMyPasswordChangeRequest} [managerAccountControllerDtoMyPasswordChangeRequest] 
     * @param {module:api/ManagerAccountApi~apiManagerAccountMyPasswordChangePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiManagerAccountMyPasswordChangePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerAccountControllerDtoMyPasswordChangeRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/ManagerAccount/MyPasswordChange', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerAccountMyRemoveTwofactorPost operation.
     * @callback module:api/ManagerAccountApi~apiManagerAccountMyRemoveTwofactorPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerAccountControllerDtoMyRemoveTwoFactorRequest} [managerAccountControllerDtoMyRemoveTwoFactorRequest] 
     * @param {module:api/ManagerAccountApi~apiManagerAccountMyRemoveTwofactorPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiManagerAccountMyRemoveTwofactorPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerAccountControllerDtoMyRemoveTwoFactorRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/ManagerAccount/MyRemoveTwofactor', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerAccountNotificationListPost operation.
     * @callback module:api/ManagerAccountApi~apiManagerAccountNotificationListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ManagerAccountControllerDtoNotificationListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/ManagerAccountApi~apiManagerAccountNotificationListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ManagerAccountControllerDtoNotificationListResponse}
     */
    apiManagerAccountNotificationListPost(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = ManagerAccountControllerDtoNotificationListResponse;
      return this.apiClient.callApi(
        '/api/ManagerAccount/NotificationList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerAccountNotificationTokenCreatePost operation.
     * @callback module:api/ManagerAccountApi~apiManagerAccountNotificationTokenCreatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerAccountControllerDtoNotificationTokenCreateRequest} [managerAccountControllerDtoNotificationTokenCreateRequest] 
     * @param {module:api/ManagerAccountApi~apiManagerAccountNotificationTokenCreatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiManagerAccountNotificationTokenCreatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerAccountControllerDtoNotificationTokenCreateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/ManagerAccount/NotificationTokenCreate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerAccountNotificationsMarkingAsReadPost operation.
     * @callback module:api/ManagerAccountApi~apiManagerAccountNotificationsMarkingAsReadPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerAccountControllerDtoNotificationsMarkingAsReadRequest} [managerAccountControllerDtoNotificationsMarkingAsReadRequest] 
     * @param {module:api/ManagerAccountApi~apiManagerAccountNotificationsMarkingAsReadPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiManagerAccountNotificationsMarkingAsReadPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerAccountControllerDtoNotificationsMarkingAsReadRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/ManagerAccount/NotificationsMarkingAsRead', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerAccountNotificationsRemovePost operation.
     * @callback module:api/ManagerAccountApi~apiManagerAccountNotificationsRemovePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerAccountControllerDtoNotificationsRemoveRequest} [managerAccountControllerDtoNotificationsRemoveRequest] 
     * @param {module:api/ManagerAccountApi~apiManagerAccountNotificationsRemovePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiManagerAccountNotificationsRemovePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerAccountControllerDtoNotificationsRemoveRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/ManagerAccount/NotificationsRemove', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
